const Layout = () => import('@/layout/index.vue')

export default {
    path: '/withdraw',
    component: Layout,
    redirect: '/withdraw/index',
    name: 'withdraw',
    meta: {
        title: '提现记录',
        icon: 'withdraw'
    },
    children: [
        {
            path: 'index',
            name: 'WithdrawIndex',
            component: () => import('@/views/withdraw/index.vue'),
            meta: {
                title: '提现记录',
                sidebar: false,
                breadcrumb: false,
                activeMenu: '/withdraw',
                auth: ['withdraw']
            }
        }
    ]
}
